import Vue from "vue";
import Vuex from "vuex";
import {
    get
} from '@/api/common/index'
import {
    Message
} from 'element-ui'
import router from '../router'
import CryptoJS from "crypto-js";
import storage from '../helper/storage'
export function getUserInfo() {
    let userInfo = null
    let exists = false
    return new Promise((resolve, reject) => {
        let userStrorage = window.localStorage.getItem("rent_userInfo")
        if (getLocalToken()) {
            if (userStrorage) {
                try {
                    var tk = userStrorage; //把存储的值取出
                    var bytes = CryptoJS.AES.decrypt(tk, 'ntrcgy2021');
                    userInfo = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                    exists = true;
                    resolve(userInfo);
                } catch (e) {
                    removeUserInfo()
                    reject(e);
                }
            }
        } else {
            removeUserInfo()
            userStrorage = window.localStorage.getItem("rent_userInfo")
        }
        if (!exists) {
            if (getLocalToken()) {
                get('/api/person/get_person_info').then(res => {
                    userInfo = res.data;
                    let userInfo1 = CryptoJS.AES.encrypt(JSON.stringify(userInfo), 'ntrcgy2021').toString();
                    window.localStorage.setItem("rent_userInfo", userInfo1)
                    resolve(userInfo);
                }).catch(error => {
                    reject(error);
                })
            } else {
                resolve(userStrorage);
                localStorage.removeItem('userType')
            }
        }
    });
}
export function getCompanyInfo() {
    let userInfo = null
    let exists = false
    return new Promise((resolve, reject) => {
        let userStrorage = window.localStorage.getItem("company_userInfo")
        if (getLocalToken()) {
            if (userStrorage) {
                try {
                    var tk = userStrorage; //把存储的值取出
                    var bytes = CryptoJS.AES.decrypt(tk, 'ntrcgy2021');
                    userInfo = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                    exists = true;
                    resolve(userInfo);
                } catch (e) {
                    removeCompanyInfo()
                    reject(e);
                }
            }
        } else {
            removeCompanyInfo()
            userStrorage = window.localStorage.getItem("company_userInfo")
        }
        if (!exists) {
            if (getLocalToken()) {
                get('/api/company_apply/get_company_base_info').then(res => {
                    userInfo = res.data;
                    let userInfo1 = CryptoJS.AES.encrypt(JSON.stringify(userInfo), 'ntrcgy2021').toString();
                    window.localStorage.setItem("company_userInfo", userInfo1)
                    resolve(userInfo);
                }).catch(error => {
                    reject(error);
                })
            } else {
                resolve(userStrorage);
            }
        }
    });
}


// export function checkRenter () {
//   getUserInfo().then(data => {
//     get('/api/rent/check_renter', {'cert_no': data.certNo}).then(res => {
//       if (res.success === false) {
//         if (res.data) {
//           Message(res.data)
//           router.push({path: 'UserIndex'})
//         }
//       }
//     })
//   })
// }

export function removeUserInfo() {
    return window.localStorage.removeItem('rent_userInfo')
}

export function removeCompanyInfo() {
    return window.localStorage.removeItem('company_userInfo')
}

export function getLocalToken() {
    var tk = storage.get('token'); //把存储的值取出
    if (tk) {
        var bytes = CryptoJS.AES.decrypt(tk, 'ntrcgy2021');
        return bytes.toString(CryptoJS.enc.Utf8)
    } else {
        return tk
    }
}

export function setLocalToken(token) {
    let token1 = CryptoJS.AES.encrypt(token, 'ntrcgy2021').toString();
    return storage.set('token', token1, 1440)
}

export function removeLocalToken() {
    return window.localStorage.removeItem('token')
}




Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        currentNav: 0,
        isShowStep: true,
    },
    mutations: {
        changeCurrentNav(state, data) {
            state.currentNav = data
        },
        changeIsShowStep(state, data) {
            state.isShowStep = data
        }
    },
    actions: {},
    modules: {}
});